import { exampleUser, User } from '../user';

export type AdCreativeReviewOrigin = 'internal' | 'external';

export interface AdCreativeReview {
  id: number;
  creativeID: number;
  user: User;
  type: AdCreativeReviewOrigin;
  approved: boolean;
  /**
   * Set on external verdicts an Employee recorded before the approver name was
   * retired. Historical rows only — nothing writes it now.
   */
  clientApproverName?: string;
  notes?: string;
  /**
   * True when an Employee recorded this external verdict on the client's behalf,
   * rather than the client submitting it themselves. Describes this row only; a
   * superseding verdict replaces it rather than appending, so this is not a history.
   */
  clientAttestedByEmployee?: boolean;
  createdAt: number;
  updatedAt: number;
}

export const exampleAdCreativeReview: AdCreativeReview = {
  id: 1,
  creativeID: 1,
  user: exampleUser,
  type: 'internal',
  approved: true,
  createdAt: 0,
  updatedAt: 0,
};

export interface AdCreativeReviewDTO {
  approved: boolean;
  /**
   * Records the verdict as the client's, whoever submitted it. An Employee must
   * set this — their verdict stands for the client's, in both directions — and a
   * client's own submission is treated as one regardless. Allowed from any
   * pre-published state (Draft/Pending/Ready/Rejected); only a Published creative
   * is blocked.
   *
   * The flag is explicit rather than inferred from the session role so that a
   * future internal-review feature doesn't silently start writing client verdicts.
   */
  asClientVerdict?: boolean;
  /** On a rejection, the reason. On an approval, optional context. */
  notes?: string;
}
